import {Injectable} from "@angular/core";
import {Action, Selector, State, StateContext} from "@ngxs/store";
import {AppStateInterface} from "../models/app-state.interface";
import {AppHelper} from "../helpers/app.helper";
import {UserAction} from "../actions/user-action";
import Authenticate = UserAction.Authenticate;
import {JwtHelper} from "../helpers/jwt.helper";
import RefreshToken = UserAction.RefreshToken;
import FetchProfile = UserAction.FetchProfile;
import {RequestService} from "../services/request.service";
import ChangeDarkMode = UserAction.ChangeDarkMode;

@State<AppStateInterface>({
  name: 'appData',
  defaults: {
    profile: { email: '', token: '', refreshToken: '' },
    configId: 0,
    darkMode: true,
    favoritos: [],
    favorites: [],
    carteraColumnas: [],
    operacionColumnas: []
  }
})
@Injectable()
export class AppState {

  constructor(private requestService: RequestService) {
  }

  @Selector()
  static profile(state: any) {

    return state.profile;
  }

  @Selector()
  static darkMode(state: any) {

    return state.darkMode;
  }

  @Selector()
  static favoritos(state: any) {

    return state.favoritos;
  }

  @Selector()
  static favorites(state: any) {

    return state.favorites;
  }

  @Selector()
  static carteraColumnas(state: any) {

    return state.carteraColumnas;
  }

  @Selector()
  static operacionColumnas(state: any) {

    return state.operacionColumnas;
  }

  @Action(Authenticate)
  async authenticate({getState, setState}: StateContext<AppStateInterface>, action: Authenticate) {

    const state = getState();

    try {

      const data: any =  await this.requestService.post('login',
        { params: { email: action.email, password: action.password }, ignoreToken: true });

      const profile: any = JwtHelper.GetProfile(data.token);
      profile.token = data.token;
      profile.refreshToken = data.refreshToken;

      setState({ ...state, ... { profile: { ... state.profile, ... profile, ...{ authProfile: null } } } });
    } catch (e) {

      AppHelper.DevPrint(e);
      const profile: any = { email: action.email, authError: e?.error ? e.error.message || e.error.detail : e.message };
      setState({ ...state, ... { profile: profile } });
      return;
    }
  }

  @Action(RefreshToken)
  async refreshToken({getState, setState}: StateContext<AppStateInterface>) {

    const state = getState();

    if (state?.profile?.refreshToken) {

      try {

        const data: any = await this.requestService.post('refresh_token', { params:
            { refreshToken: state.profile.refreshToken }, ignoreToken: true, hideLoading: true });

        setState({ ...state, ... { profile: { ... state.profile, ... { token:  data.token, refreshToken: data.refreshToken } } } });
      } catch (e) {

        AppHelper.DevPrint(e);
        setState({ ...state, ... { profile: { ... state.profile, ... { token:  '', refreshToken: '' } } } });

        // Finaliza la sesion
        this.requestService.onEndSession.emit();
      }
    }

  }

  @Action(FetchProfile)
  async fetchProfile({getState, setState}: StateContext<AppStateInterface>, action: FetchProfile){

    const state = getState();
    try {

      const data: any = await this.requestService.get('user_profile',
        { hideLoading: action.hideLoading, params: { id: action.id } });

      const config = data.config;
      delete data.config;

      setState({ ...state, ... {
        profile: { ... state.profile, ...{ locale: 'es-ES' }, ... data },
        configId: config.id,
        darkMode: !!config?.darkmode,
        favoritos: config?.favoritos || [],
        favorites: config?.favorites || [],
        carteraColumnas: config?.columnas?.cartera || [],
        operacionColumnas: config?.columnas?.operacion || [],
      } });

    } catch (e) {

      AppHelper.DevPrint(e);
      setState({ ...state, ... { profile: { ... state.profile, ... { token:  '', refreshToken: '' } } } });
    }
  }

  @Action(ChangeDarkMode)
  async changeDarkMode({getState, setState}: StateContext<AppStateInterface>, action: ChangeDarkMode){

    const state = getState();
    setState({ ...state, ... { darkMode: action.mode } });
  }

}
